'use strict';

const mask = require('inputmask.numeric.extensions');

mask({
	alias: 'currency',
	prefix: '£',
	rightAlign: false,
	digitsOptional: true,
	placeholder: ''
}).mask(document.querySelectorAll('.js-mask-currency'));